<template>
  <div class="relative">
    <div class="week-picker__content flex">
      <div class="content">
        <div class="number hint--top"
             v-for="(week, index) in weeks"
             v-tooltip
             :aria-label="week.date | tooltipDate"
             :class="[{'isSelected': week.isSelected}, {'isCopyWeek': week.isCopyWeek}]"
             :key="week.serverDate"
             @click="toggleWeek(index)">
            <span :class="{'isNow': week.isNow}">
              {{ week.weekNum }}
            </span>
        </div>
      </div>
      <div class="sortcuts">
        <select class="copy-week-picker-school-year-selector"
                v-if="!calid"
                :value="activeSchoolYear.id"
                @change="setActiveSchoolYear">
          <option v-for="year in activeSchoolYears"
                  :value="year.id"
                  :key="year.id">
            {{ year.name }}
          </option>
        </select>
        <ul>
          <li class="sortcuts__headline">
            <b>{{ $t('vue2.copycalendar.markWeeksFrom') }}
              <div class="no-tag" :class="{'tag': !showStartPasteWeek}">
                {{ startPasteWeek | week }}
                <span class="icon-cross2 pointer"
                      v-show="!showStartPasteWeek"
                      @click.stop="eraseStartDate">
                    </span>
              </div>
            </b>
          <li>
              <span class="sortcut__clickable"
                    @click="selectAll">
                <span class="bttn width-100 btn-trans">
                {{ $t('vue2.copycalendar.allWeeks') }}
                  </span>
              </span>
          </li>
          <li>
              <span class="sortcut__clickable"
                    @click="selectOddWeeks">
                 <span class="bttn width-100 btn-trans">
                {{ $t('vue2.copycalendar.oddWeeks') }}
                 </span>
              </span>
          </li>
          <li>
              <span class="sortcut__clickable"
                    @click="selectEvenWeeks">
                 <span class="bttn width-100 btn-trans">
                {{ $t('vue2.copycalendar.evenWeeks') }}
                 </span>
              </span>
          </li>
          <li>
              <span class="sortcut__clickable"
                    @click="removeAllSelectedWeeks">
                 <span class="bttn btn-trans width-100 btn-remove">
                {{ $t('vue2.copycalendar.unselectAll') }}
                 </span>
              </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import eventbus from '../../../eventbus'
import docendo from '../../../docendo'
import moment from 'moment'
import spinner from '../../common/SpinnerButton'

export default {
  props: {
    calid: {
      type: Number
    },
    date: {}
  },
  components: {spinner},
  directives: {
    tooltip: {
      inserted: function (el) {
        const headerBottom = document.querySelector('.up-modal__header').getBoundingClientRect().bottom
        const elBottom = el.getBoundingClientRect().bottom
        const calc = elBottom - headerBottom
        if (calc < 100) {
          el.classList.remove('hint--top')
          el.classList.add('hint--bottom')
        }
      },
      update: function (el) {
        const headerBottom = document.querySelector('.up-modal__header').getBoundingClientRect().bottom
        const elBottom = el.getBoundingClientRect().bottom
        const calc = elBottom - headerBottom
        if (calc < 100) {
          el.classList.remove('hint--top')
          el.classList.add('hint--bottom')
        }
      }
    }
  },
  data () {
    return {
      modal: false,
      today: eventbus.now,
      copyDate: eventbus.now,
      selectedWeeks: [],
      calStartDate: eventbus.now,
      calEndDate: eventbus.now,
      calCurrentDate: eventbus.now,
      calType: '',
      startPasteWeek: eventbus.now,
      weeks: [],
      deleteEvents: true
    }
  },
  watch: {
    selectedWeeks () {
      this.$emit('weeks', this.selectedWeeks)
    }
  },
  computed: {
    activeSchoolYears () {
      return this.$store.state.activeSchoolYears
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    showStartPasteWeek () {
      return moment(this.startPasteWeek).isSame(this.calStartDate)
    },
    noneSelected () {
      return this.selectedWeeks.length === 0
    },
    firstDayOfTheWeek () {
      // 1 == monday
      let start = 1
      if (typeof window.SCHOOL.first_day_of_week_num !== 'undefined') {
        start = window.SCHOOL.first_day_of_week_num
      }
      return start
    }
  },
  filters: {
    tooltipDate (date) {
      let start = moment(date)
      let start2 = moment(date).format('DD. MMM')
      let startFormat = start.format('DD')
      let end = moment(date).add(6, 'days')
      let endFormat = moment(date).add(6, 'days').format('DD. MMM YYYY')
      // If same month
      if (moment(start).format('MM') === moment(end).format('MM')) {
        return startFormat + ' - ' + endFormat
      } else {
        return start2 + ' - ' + endFormat
      }
    },
    week (date) {
      return moment(date).isoWeek()
    }
  },
  methods: {
    setActiveSchoolYear (evt) {
      this.$store.commit('setlocalActivatedSchoolYear', evt.target.value)
      this.setStartAndEndDateBasedOnSchoolYear()
    },
    setStartAndEndDate () {
      let isCalDateNotWithinASchoolYear = true
      let startDate
      let endDate
      this.activeSchoolYears.forEach(year => {
        startDate = moment(year.employee_time_start).startOf('isoweek')
        endDate = moment(year.employee_time_end).endOf('isoweek')
        if (this.isCalDateWithinRange(startDate, endDate)) {
          this.calStartDate = startDate
          this.calEndDate = endDate
          isCalDateNotWithinASchoolYear = false
        }
      })
      this.createWeeks()
      this.$emit('isWithinCalRange', isCalDateNotWithinASchoolYear)
    },
    setStartAndEndDateBasedOnSchoolYear () {
      this.calStartDate = this.activeSchoolYear.employee_time_start
      this.calEndDate = this.activeSchoolYear.employee_time_end
      this.createWeeks()
    },
    isCalDateWithinRange (start, end) {
      let lockupdate = moment(this.date).format('YYYY-MM-DD')
      return moment(lockupdate).isBetween(start, end) || moment(lockupdate).isSame(start) || moment(lockupdate).isSame(end)
    },
    createWeeks () {
      const start = moment(this.calStartDate).day(this.firstDayOfTheWeek)
      const end = this.calEndDate
      let startWeek = moment(start).isoWeek()
      let diff = moment(end).diff(start, 'week')
      let max = startWeek + diff
      let weeks = []
      for (let i = startWeek; i <= max; i++) {
        let date = moment(start).isoWeek(i).day(this.firstDayOfTheWeek)
        weeks.push({
          date: date,
          isSelected: false,
          serverDate: moment(date).format('YYYY-MM-DD'),
          weekNum: date.isoWeek(),
          isNow: moment(date).format('GGGG-WW') === moment().format('GGGG-WW'),
          isCopyWeek: false
        })
      }
      this.weeks = weeks
    },
    getCalDatesAndCreateWeeks () {
      docendo.calendar(this.calid, data => {
        this.calType = data.type
        this.calStartDate = data.start_date
        this.calEndDate = data.end_date
        this.setStartAndEndDate()
        this.setStartWeek()
      })
    },
    setStartWeek () {
      const weekNum = moment(this.date).isoWeek()
      const index = this.findWeek(weekNum)
      if (this.weeks[index] !== undefined) {
        this.weeks[index].isCopyWeek = true
        this.startPasteWeek = this.date
      }
    },
    selectWeek (i) {
      if (!this.weeks[i].isSelected && !this.weeks[i].isCopyWeek) {
        this.selectedWeeks.push(this.weeks[i].serverDate)
        this.weeks[i].isSelected = true
      }
    },
    removeWeek (i) {
      this.weeks[i].isSelected = false
      let selectedIndex = this.selectedWeeks.indexOf(this.weeks[i].serverDate)
      this.selectedWeeks.splice(selectedIndex, 1)
    },
    toggleWeek (index) {
      if (this.selectedWeeks.length < 1 || this.showStartPasteWeek) {
        this.startPasteWeek = this.weeks[index].date
      }
      if (this.weeks[index].isCopyWeek) {
        return
      }
      if (!this.weeks[index].isSelected) {
        this.selectWeek(index)
      } else {
        this.removeWeek(index)
      }
    },
    findWeek (weekNum) {
      for (let i = 0; i < this.weeks.length; i++) {
        if (this.weeks[i].weekNum === weekNum) {
          return i
        }
      }
    },
    selectAll () {
      for (let i = 0; i < this.weeks.length; i++) {
        if (moment(this.weeks[i].date).isSameOrAfter(this.startPasteWeek)) {
          this.selectWeek(i)
        }
      }
    },
    selectEvenWeeks () {
      for (let i = 0; i < this.weeks.length; i++) {
        if (moment(this.weeks[i].date).isSameOrAfter(this.startPasteWeek)) {
          if (this.isEven(this.weeks[i].date.isoWeek())) {
            this.selectWeek(i)
          }
        }
      }
    },
    selectOddWeeks () {
      for (let i = 0; i < this.weeks.length; i++) {
        if (moment(this.weeks[i].date).isSameOrAfter(this.startPasteWeek)) {
          if (this.isOdd(this.weeks[i].date.isoWeek())) {
            this.selectWeek(i)
          }
        }
      }
    },
    isEven (n) {
      return /^-?\d*[02468]$/.test(n)
    },
    isOdd (n) {
      return /^-?\d*[13579]$/.test(n)
    },
    removeAllSelectedWeeks () {
      this.selectedWeeks = []
      for (let i = 0; i < this.weeks.length; i++) {
        this.weeks[i].isSelected = false
      }
    },
    close () {
      this.modal = false
      this.feedback = false
    },
    eraseStartDate () {
      this.startPasteWeek = this.calStartDate
    }
  },
  beforeMount () {
    if (this.calid) {
      this.getCalDatesAndCreateWeeks()
    } else {
      this.setStartAndEndDateBasedOnSchoolYear()
    }
  }
}
</script>

<style scoped>
@import '../../../assets/css/variables.css';

.relative {
  position: relative;
}

.sortcuts {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 180px;
  border-left: 1px solid #e4e4e4;
  box-sizing: border-box;
  background-color: #fafafa;
  overflow: auto;
}

.sortcuts__headline {
  margin-left: 15px;
}

.sortcuts li {
  align-items: center;
  box-shadow: inset 0 -1px 0 0 rgba(226, 230, 234, .45);
  display: flex;
  height: 50px;
  position: relative;
}

.sortcuts li > .sortcut__clickable {
  cursor: pointer;
  display: flex;
  flex: 1;
  height: 100%;
  align-items: center;
  padding: 0 15px;
  transition: 0.3s;
}

.sortcuts li > .sortcut__clickable:active {
  transform: scale(.9);
}

.sortcuts ul {
  margin: 0;
}

.content {
  margin-right: 180px;
  flex-wrap: wrap;
  display: flex;
  width: 418px;
  height: 310px;
  padding: 3px;
  justify-content: center;
}

.number {
  padding: 0 10px;
  height: 42px;
  width: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2px;
  cursor: pointer;
  border-radius: 50%;
  border: 1px solid #edf0f5;
  user-select: none;
  transition: 0.25s;
}

.number:hover {
  border-color: var(--blue);
}

.number:active {
  transform: scale(.9);
}

.isSelected {
  background-color: var(--blue);
  color: white;
}

.isNow:after {
  content: '';
  z-index: 100;
  background: var(--blue);
  border-radius: 50%;
  display: block;
  height: .5em;
  left: 50%;
  margin: 0em 0 0 -0.22em;
  position: absolute;
  width: .5em;
}

.isSelected .isNow:after, .isCopyWeek .isNow:after {
  background: white;
}

.isCopyWeek {
  background: var(--dark-blue) !important;
  color: white !important;
  border: none !important;
}

.tag {
  color: var(--blue);
  background: white;
  border-radius: 6px;
}

.no-tag {
  top: 14px;
  right: 15px;
  position: absolute;
  padding: 0 6px;
  font-size: 15px;
}

.no-tag > span {
  position: relative;
  top: 1px;
  right: 0;
}

.btn-remove {
  color: var(--danger);
}

.submit-message {
  margin: 20px auto;
  font-size: 14px;
}

.submit-message > h2 {
  color: var(--blue);
}

.submit-message__icon {
  font-size: 40px;
  color: var(--blue);
}

.delete-option > * {
  cursor: pointer;
}

.delete-option > label {
  user-select: none;
  font-weight: normal;
}

.delete-option > input {
  margin-left: 2px;
}

.copy-week-picker-school-year-selector {
  width: calc(100% - 20px);
  margin: 10px;
  border-radius: 4px;
}

</style>



// WEBPACK FOOTER //
// WeekPicker.vue?3f22e6fc